import { useRef, useState, forwardRef, useImperativeHandle } from "react";
import { v4 as uuidv4 } from "uuid";
import { useWindowSize } from "../../../../utils/useWindowSize";

import { Box, Button, Grid, Stack, TextField } from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import GamesIcon from "@mui/icons-material/Games";

import { userState } from "../../../../interface/MainInterface";
import { HttpAdminApi } from "../../../../interface/admin-api";
import { HttpAdminIotApi } from "../../../../interface/admin-iot-rest-api";
import { CommonUtils } from "../../../../utils/common_utils";
import Toast from "../../../../utils/Toast";

import LiveEventApplyList from "./LiveEventApplyList";
import LiveEventWinnerList from "./LiveEventWinnerList";
import dayjs from "dayjs";
import GiftInfoModule from "./GiftInfoModule";
import SelectGameForm from "./SelectGameForm";
import GameInfoModule from "../GameInfoModule";
import DrawInfoModule from "./DrawInfoModule";

interface propsType {
  userState: userState;
  channelInfo: any;
  callback: any;
}

const adminApi = new HttpAdminApi();
const adminIotApi = new HttpAdminIotApi();
const cUtils = new CommonUtils();

const LiveEventDetailModule = (props: propsType, ref: any) => {
  const windowSize = useWindowSize();
  const toastRef: any = useRef();

  const [eventInfo, setEventInfo] = useState<any>({});
  const [giftModalOpen, setGiftModalOpen] = useState(false);
  const [gameModalOpen, setGameModalOpen] = useState(false);
  const [drawModalOpen, setDrawModalOpen] = useState(false);

  const [timeout, setTimeout] = useState(0);

  const applyListRef: any = useRef();

  const get_event_info = async (_broad_seq: string, _event_seq: string) => {
    const param: any = {
      command: "get_event_info",
      broad_seq: _broad_seq,
      event_seq: _event_seq,
    };

    const res = await adminApi.post(param);
    if (res.code === "200") {
      setEventInfo(res.response.event_info);
      setTimeout(res.response.event_info.event_condition.timeout);
    }
  };

  const sendIoTMessage = async (topic: string, payload: any) => {
    const param: any = {
      topic: topic,
      payload: payload,
    };

    await adminIotApi.send_iot_message(param);
  };

  const sendMessage = async (msg: string, meta: string) => {
    try {
      const msgId = uuidv4();
      // const topic = `live/${props.channelInfo.broad_seq}/payload`;
      const chatPayload = {
        command: "send_chat_history",
        topic: "chat/message",
        broad_seq: props.channelInfo.broad_seq,
        ChannelArn: props.channelInfo.chime_channel_arn,
        Content: msg,
        CreatedTimestamp: "",
        LastUpdatedTimestamp: "",
        MessageId: msgId,
        Persistence: "PERSISTENT",
        Redacted: false,
        Sender: {
          Arn: props.channelInfo.chime_admin_arn,
          Name: props.userState.name,
        },
        Status: {
          Value: "SENT",
        },
        Type: "STANDARD",
        Metadata: meta,
      };
      // const iotParam: any = {
      //   topic: topic,
      //   payload: chatPayload,
      // };
      // IoT 채팅 메세지 전송
      // await adminIotApi.send_iot_message(iotParam);
      // 채팅 히스토리 저장
      await adminApi.post(chatPayload);
    } catch (e) {
      console.error("send msg ERROR : ", e);
    }
  };

  // 게임 시작하기
  const start_event = async () => {
    if (!window.confirm("이벤트를 시작하시겠습니까?")) return;

    const param: any = {
      command: "start_event",
      broad_seq: props.channelInfo.broad_seq,
      user_id: props.userState.id,
      event_info: {
        event_seq: eventInfo.sk,
      },
    };

    const res = await adminApi.post(param);
    if (res.code === "200") {
      props.callback({ command: "start_event", info: eventInfo });
    } else if (res.code === "201") {
      window.alert("이미 진행중인 게임이 있습니다. 기존게임을 종료 후 다시 시도하세요.");
    } else {
      console.error(res.response.error_msg);
    }
  };

  const update_event = async () => {
    if (!window.confirm("제한시간을 변경하시겠습니까?")) return;
    if (timeout === eventInfo.event_condition.timeout) {
      window.alert("변경사항이 없습니다.");
      return;
    }
    const param = {
      command: "update_event",
      broad_seq: props.channelInfo.broad_seq,
      user_id: props.userState.id,
      event_info: {
        event_seq: eventInfo.sk,
        timeout,
      },
    };

    const res = await adminApi.post(param);
    if (res.code !== "200") {
      toastRef.current?.toast(`${res.response.error_msg}`, "error", 3000, {
        vertical: "top",
        horizontal: "center",
      });
    } else {
      toastRef.current?.toast("이벤트 업데이트 성공", "success", 3000, {
        vertical: "top",
        horizontal: "center",
      });
    }
  };

  // 당첨자 발표
  const sendWinner = async (_drawResult: any, _drawNumberIng: number) => {
    let winner = "";
    let adminWinner = "";
    for (let i = 0; i < _drawResult.length; i++) {
      winner = winner + cUtils.maskingChar(_drawResult[i].user_id.split("@")[0]);
      adminWinner = adminWinner + _drawResult[i].user_id.split("@")[0];
      if (i !== _drawResult.length - 1) {
        winner = winner + ", ";
        adminWinner = adminWinner + ", ";
      }
    }
    const msg = `${_drawNumberIng}명 추첨 결과\n${winner} 님\n당첨을 축하드립니다!`;
    const meta = `${_drawNumberIng}명 추첨 결과\n${adminWinner} 님\n당첨을 축하드립니다!`;
    await sendMessage(msg, meta);
  };

  // 추첨
  const draw_event = async (_eventInfo: any, _drawResult: any) => {
    get_event_info(props.channelInfo.broad_seq, _eventInfo.sk);
    // const topic = `live/${props.channelInfo.broad_seq}/payload`;
    // const payload: any = {
    //   topic: "game",
    //   prot: "draw",
    //   event_seq: _eventInfo.sk,
    // };
    // await sendIoTMessage(topic, payload);
    // await sendWinner(_drawResult, _eventInfo.event_condition.draw_number);
  };

  // 당첨자 공지
  const send_winner = async () => {
    if (!window.confirm("당첨자를 재공지 하시겠습니까?")) return;

    const topic = `live/${props.channelInfo.broad_seq}/payload`;
    const payload: any = {
      topic: "game",
      prot: "draw",
      event_seq: eventInfo.sk,
    };
    await sendIoTMessage(topic, payload);
    await sendWinner(
      eventInfo.draw_result,
      eventInfo.event_condition?.draw_number ? eventInfo.event_condition?.draw_number : eventInfo.draw_number
    );
  };

  const send_draw_result = async (prizeName: string, winners: any[]) => {
    if (winners.length === 0) {
      window.alert("당첨자가 없습니다.");
      return;
    }

    const payload = {
      command: "send_draw_result_ver2",
      broad_seq: props.channelInfo.broad_seq,
      event_seq: eventInfo.sk,
      ofrSeq: winners[0].ofrSeq,
      ofrNm: prizeName,
      winners: winners,
    };
    console.log("send_draw_result_ver2 payload : ", payload);
    const res = await adminApi.post(payload);
    console.log("send_draw_result_ver2 : ", res);
    if (res.code === "200") {
    }
  };

  const send_draw_info_hub = async () => {
    const param: any = {
      command: "send_draw_info_hub",
      event_seq: eventInfo.sk,
      broad_seq: props.channelInfo.broad_seq,
    };

    // setIsLoading(true);
    const res = await adminApi.post(param);
    console.log("res : ", res);
    if (res.code === "200") {
      toastRef.current?.toast("당첨자를 전송했습니다.", "success", 3000, {
        vertical: "top",
        horizontal: "center",
      });
    } else {
      toastRef.current?.toast("[허브] 이벤트 데이터 전송 실패, 담당자 문의 바랍니다.", "error", 5000, {
        vertical: "top",
        horizontal: "center",
      });
      console.error("send_draw_info_hub : ", res.response.error_msg);
    }
  }

  const send_apply_info_hub = async () => {
    const param: any = {
      command: "send_apply_info_hub",
      event_seq: eventInfo.sk,
      broad_seq: props.channelInfo.broad_seq,
    };

    // setIsLoading(true);
    const res = await adminApi.post(param);
    console.log("res : ", res);
    if (res.code === "200") {
      toastRef.current?.toast("응모자를 전송했습니다.", "success", 3000, {
        vertical: "top",
        horizontal: "center",
      });
    } else {
      toastRef.current?.toast("[허브] 이벤트 데이터 전송 실패, 담당자 문의 바랍니다.", "error", 5000, {
        vertical: "top",
        horizontal: "center",
      });
      console.error("sensend_apply_info_hub : ", res.response.error_msg);
    }
  }

  // 당첨자 다운로드
  const downloadWinnerExcelList = () => {
    if (eventInfo.draw_result.length === 0) return;
    let winnerContent: any = [];
    let mergeCells: any = [];

    const title: any = ["방송명 : ", props.channelInfo.broad_title];
    winnerContent.push(title);
    mergeCells.push({ s: { r: 0, c: 1 }, e: { r: 0, c: 5 } });

    const eventName: any = [
      "이벤트명 : ",
      eventInfo.event_condition?.title
        ? eventInfo.event_condition?.title
        : `추첨이벤트${dayjs(eventInfo.start_dtm).format("YYYY-MM-DD HH:mm")}`,
    ];
    winnerContent.push(eventName);
    mergeCells.push({ s: { r: 1, c: 1 }, e: { r: 1, c: 5 } });

    const eventDtm: any = ["이벤트 일시 : ", dayjs(eventInfo.start_dtm).format("YYYY-MM-DD hh:mm")];
    winnerContent.push(eventDtm);
    mergeCells.push({ s: { r: 2, c: 1 }, e: { r: 2, c: 5 } });

    // 한줄
    winnerContent.push([]);

    let header: any = ["순번", "아이디", "고객번호", "응모시간", "경품명"];
    winnerContent.push(header);

    // 각 행 순번 만들기
    let winnerIndex = 1;
    // 내용 생성
    for (const winner_info of eventInfo.draw_result) {
      const detail = [
        winnerIndex,
        winner_info["user_id"],
        winner_info["cust_no"],
        dayjs(winner_info["apply_dtm"]).format("YYYY-MM-DD HH:mm:ss"),
        winner_info["ofrNm"],
      ];
      winnerContent = [...winnerContent, detail];
      winnerIndex += 1;
    }
    // 컬럼 넓이
    const colWidth = [{ wpx: 150 }, { wpx: 150 }, { wpx: 150 }, { wpx: 150 }, { wpx: 110 }];

    const winnerSheetName = "당첨자 내역";

    // 파일명
    const fileName = `[${props.channelInfo.broad_title}]-${eventInfo.event_condition?.title
      ? eventInfo.event_condition?.title
      : `추첨이벤트${dayjs(eventInfo.start_dtm).format("YYYY-MM-DD HH:mm")}`
      }(${dayjs(String(eventInfo.start_dtm)).format("YYYY-MM-DD hh:mm")})-당첨자내역.xlsx`;
    cUtils.downloadExcel(winnerContent, colWidth, winnerSheetName, fileName, mergeCells);
  };

  const closeGiftModal = () => {
    setGiftModalOpen(false);
  };

  const closeGameModal = () => {
    setGameModalOpen(false);
  };

  const closeDrawModal = () => {
    setDrawModalOpen(false);
  };

  const convertGameKind = (gameKind: string) => {
    switch (gameKind) {
      case "ladder":
        return "사다리타기";
      case "choice":
        return "4지선다";
      case "oxquiz":
        return "O,X퀴즈";
      case "short":
        return "주관식퀴즈";
    }
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    get_event_info,
  }));

  return (
    <>
      {!cUtils.isEmptyObj(eventInfo) && (
        <Box>
          <Box sx={{ mb: 2 }}></Box>
          <Stack direction={windowSize.width > 768 ? "row" : "column"} spacing={windowSize.width > 768 ? 2 : 1}>
            <Box sx={{ minWidth: "30%" }}>
              <Stack
                direction={"column"}
                spacing={windowSize.width > 768 ? 2 : 1}
                sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
              >
                <Button
                  variant="text"
                  startIcon={
                    eventInfo.event_condition.flag === "apply" ? (
                      <CelebrationIcon />
                    ) : eventInfo.event_condition.flag === "authBuy" ? (
                      <ShoppingCartIcon />
                    ) : eventInfo.event_condition.flag === "game" ? (
                      <SportsEsportsIcon />
                    ) : (
                      <DoNotDisturbIcon />
                    )
                  }
                  sx={{ color: "#000000DE" }}
                >
                  {(eventInfo.event_condition.flag !== "game" ||
                    eventInfo.event_condition.game_kind !== "NEED_GAME") && (
                      <Box component="span" sx={{ color: "red", fontWeight: 700, whiteSpace: "pre" }}>
                        {eventInfo.event_condition.is_fcfs ? "선착순 " : "추첨형 "}
                      </Box>
                    )}

                  {eventInfo.event_condition.flag === "apply" ? (
                    "응모이벤트"
                  ) : eventInfo.event_condition.flag === "authBuy" ? (
                    "구매인증 이벤트"
                  ) : eventInfo.event_condition.flag === "game" &&
                    eventInfo.event_condition.game_kind !== "NEED_GAME" ? (
                    <>
                      게임 이벤트 (
                      <Box component="span" sx={{ color: "red", fontWeight: 700 }}>
                        {convertGameKind(eventInfo.event_condition.game_kind)}
                      </Box>
                      )
                    </>
                  ) : eventInfo.event_condition.flag === "game" ? (
                    "게임 이벤트"
                  ) : (
                    "미분류"
                  )}
                </Button>
                {eventInfo.event_condition.flag === "game" && eventInfo.event_condition.game_kind !== "NEED_GAME" && (
                  <>
                    <Button
                      variant="text"
                      startIcon={<GamesIcon />}
                      onClick={() => {
                        setGameModalOpen(true);
                      }}
                      sx={{ color: "#00A676" }}
                    >
                      게임 정보
                    </Button>
                    <GameInfoModule
                      openModal={gameModalOpen}
                      closeModal={closeGameModal}
                      broadSeq={props.channelInfo.broad_seq}
                      eventInfo={eventInfo}
                      callback={props.callback}
                    />
                  </>
                )}
                <TextField
                  label="이벤트명"
                  value={
                    eventInfo.event_condition?.evntNm
                      ? eventInfo.event_condition?.evntNm
                      : `추첨이벤트${dayjs(eventInfo.start_dtm).format("YYYY-MM-DD HH:mm")}`
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
                <TextField
                  label="추첨인원"
                  value={eventInfo.event_condition?.draw_number}
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
                <TextField
                  label="제한시간(초)"
                  value={timeout}
                  onChange={(e) => {
                    setTimeout(Number(e.target.value));
                  }}
                  type="number"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={eventInfo.event_status !== "CREATE"}
                  inputProps={{
                    min: 0,
                  }}
                />

                <Stack direction="row" useFlexGap spacing={2} sx={{ width: '100%' }}>
                  <Grid container spacing={2}>
                    {eventInfo.event_condition?.ofrList?.length > 0 && (
                      <Grid item xs={12} sm={6}>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setGiftModalOpen(true);
                          }}
                          fullWidth
                          sx={{
                            height: '100%'
                          }}
                        >
                          경품 리스트
                        </Button>
                        <GiftInfoModule
                          openModal={giftModalOpen}
                          closeModal={closeGiftModal}
                          gifts={eventInfo.event_condition?.ofrList}
                        />
                      </Grid>
                    )}
                    {eventInfo.event_status === "CREATE" && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            onClick={start_event}
                            fullWidth
                            disabled={
                              eventInfo.event_status !== "CREATE" ||
                              (eventInfo.event_condition.flag === "game" &&
                                eventInfo.event_condition.game_kind === "NEED_GAME")
                            }
                          >
                            이벤트 시작
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            onClick={update_event}
                            fullWidth
                            disabled={eventInfo.event_status !== "CREATE"}
                            sx={{
                              backgroundColor: "#00A676",
                              "&:hover": {
                                backgroundColor: "#00A676",
                              },
                            }}
                          >
                            제한시간 수정
                          </Button>
                        </Grid>
                      </>
                    )}
                    {eventInfo.event_status === "START" && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            fullWidth
                            onClick={() => {
                              applyListRef.current.draw_event();
                            }}
                            disabled={eventInfo.event_status !== "START"}
                          >
                            이벤트 추첨
                          </Button>
                        </Grid>
                        {props.channelInfo.broad_status === "VOD" && (
                          <Grid item xs={12} sm={6}>
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={() => {
                                send_apply_info_hub();
                              }}
                              sx={{
                                backgroundColor: '#32A3B4',
                                "&:hover": {
                                  backgroundColor: "#32A3B4",
                                },
                              }}
                            >
                              응모자 전송 [HUB]
                            </Button>
                          </Grid>
                        )}
                      </>
                    )}
                    {eventInfo.event_status === "END" && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="outlined"
                            color="error"
                            fullWidth
                            onClick={() => {
                              setDrawModalOpen(true);
                              // send_winner();
                            }}
                            disabled={eventInfo.event_status !== "END"}
                          >
                            경품별 당첨자 공지
                          </Button>
                          <DrawInfoModule
                            openModal={drawModalOpen}
                            closeModal={closeDrawModal}
                            drawResult={eventInfo.draw_result}
                            onAnnounce={send_draw_result}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            variant="contained"
                            fullWidth
                            onClick={() => {
                              downloadWinnerExcelList();
                            }}
                            disabled={eventInfo.event_status !== "END"}
                          >
                            당첨자 다운로드
                          </Button>
                        </Grid>
                        {props.channelInfo.broad_status === "VOD" && (
                          <>
                            <Grid item xs={12} sm={6}>
                              <Button
                                variant="contained"
                                fullWidth
                                onClick={() => {
                                  send_draw_info_hub();
                                }}
                                sx={{
                                  backgroundColor: '#05B15B',
                                  "&:hover": {
                                    backgroundColor: "#05B15B",
                                  },
                                }}
                                disabled={eventInfo.event_status !== "END"}
                              >
                                당첨자 전송 [HUB]
                              </Button>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Button
                                variant="contained"
                                fullWidth
                                onClick={() => {
                                  send_apply_info_hub();
                                }}
                                sx={{
                                  backgroundColor: '#32A3B4',
                                  "&:hover": {
                                    backgroundColor: "#32A3B4",
                                  },
                                }}

                                disabled={eventInfo.event_status !== "END"}
                              >
                                응모자 전송 [HUB]
                              </Button>
                            </Grid>
                          </>
                        )}
                      </>
                    )}
                  </Grid>
                </Stack>
              </Stack>
            </Box>
            {eventInfo.event_condition.game_kind === "NEED_GAME" ? (
              <SelectGameForm broadSeq={props.channelInfo.broad_seq} eventInfo={eventInfo} callback={props.callback} />
            ) : (
              <Box sx={{ width: "100%" }}>
                {eventInfo.event_status === "START" || eventInfo.event_status === "CREATE" ? (
                  <LiveEventApplyList
                    ref={applyListRef}
                    userState={props.userState}
                    channelInfo={props.channelInfo}
                    eventInfo={eventInfo}
                    callback={(payload: any) => {
                      if (payload.command === "draw_event") {
                        toastRef.current?.toast("추첨을 완료했습니다.", "success", 3000, {
                          vertical: "top",
                          horizontal: "center",
                        });
                        // draw_event(payload.info, payload.drawResult);
                        // draw_game(payload.info, payload.drawResult);
                      }
                    }}
                  />
                ) : (
                  <LiveEventWinnerList
                    userState={props.userState}
                    channelInfo={props.channelInfo}
                    eventInfo={eventInfo}
                    callback={(payload: any) => { }}
                  />
                )}
              </Box>
            )}
          </Stack>
        </Box>
      )}
      <Toast ref={toastRef} />
    </>
  );
};

export default forwardRef(LiveEventDetailModule);
